import React, { useContext, useState, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { useActiveWeb3React } from '../../hooks'

import { ButtonPrimary } from '../../components/Button'
import { useWalletModalToggle } from '../../state/application/hooks'

import IntroCard from 'components/IntroCard'
import { TYPE } from 'theme'
import axios from 'axios'
import { AutoColumn } from 'components/Column'
import { Text } from 'rebass'
import ReferralInputPanel from './ReferralInputPanel'
import { API_POOL_BASE_URL } from 'constants/links'
/* import { roundToDecimalPlace } from 'utils/data' */
import { Helmet } from 'react-helmet'
import { SkeletonText } from 'components/Skeleton'
export const Tabs = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  border-radius: 14px;
  display: flex;
  gap: 2px;
`

export const StyledTabButton = styled.button<{ isActive?: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  border: none;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: white;
  padding: 8px 16px;
  border-radius: 14px;
  font-weight: 400;
  font-size: 14px;
  transition: all 300ms;
  background: ${({ isActive }) => (isActive ? '#4AFC38' : 'transparent')};
  color: ${({ isActive }) => (isActive ? 'black' : 'white')};

  &:hover {
    color: #4afc38;
  }

  ${({ isActive }) =>
    isActive &&
    `
      &:hover {
        color: black !important;
      }
    `}
`

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  @media (min-width: 502px) {
    padding: 10px;
  }

  max-width: 500px;
`

const SubContainer = styled.div<{ bg1: boolean }>`
  background: ${({ theme }) => theme.bg0};
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const SubContainerHeader = styled.div`
  border-radius: 14px; 
  background: ${({ theme }) => theme.bg1}
  padding: 20px;
`

const SubContainerBody = styled.div`
  padding: 20px;
  background: ${({ theme }) => theme.bg0};
`

const ConnectWalletContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 25vh;
  background: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  width: 100%;

  div {
    max-width: 300px;
  }
`

const ItemContainerStyled = styled.div`
  grid-column: span 12;
  
  @media (min-width: 768px) {
    grid-column: span 6;
  }

  width: 100%;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  background: ${({ theme }) => theme.bg2}
  border-radius: 16px;
  padding: 20px;

  h2 {
    margin-top: 12px;
    margin-bottom: 0;
  }
  span {
    font-size: 32px;
    font-weight: 600;
    color: #4afc38;
  }
  p {
    font-size: 10px;
    margin-bottom: 0;
  }
`
const ContainerPointsStyled = styled.div`
  max-width: 800px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr); /* 12 columns, each taking equal width */
  gap: 12px; /* Gap between grid items */

  @media (min-width: 768px) {
    grid-template-columns: repeat(12, 1fr); /* Still 12 columns on desktop */
  }
`
const PointsProgram = () => {
  const { account, library } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const theme = useContext(ThemeContext)
  const [loading, setLoading] = useState(false)

  const [inputValue, setInputValue] = useState<string>('')
  const [username, setUsername] = useState<string | null>(null)
  const [errorMsg, setErrorMsg] = useState<string>('')

  const [points, setPoints] = useState<number>(0)
  console.log(points)

  // Function to fetch username using axios
  const fetchUsername = useCallback(async () => {
    if (!account) return

    try {
      setLoading(true)
      const response = await axios.get(`${API_POOL_BASE_URL}/api/get-id`, {
        params: { address: account },
      })

      if (response.data.success) {
        setUsername(response.data.id)
        setPoints(response.data.pts)
      } else {
        setUsername(null)
      }
    } catch (error) {
      console.error('Failed to fetch username:', error)
    } finally {
      setLoading(false)
    }
  }, [account, setLoading])

  // Fetch username on mount
  React.useEffect(() => {
    fetchUsername()
  }, [fetchUsername, account])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const alphanumericRegex = /^[a-zA-Z0-9]*$/

    if (value.length <= 18 && alphanumericRegex.test(value)) {
      setInputValue(value)
    }
  }

  const sign = async () => {
    if (!library || !account) return

    setLoading(true)
    const signer = library.getSigner()
    const timestamp = Math.floor(Date.now() / 1000)
    const message = `Please sign this message to confirm that you are the owner. Timestamp: ${timestamp}`
    setErrorMsg('')
    try {
      const signedMessage = await signer.signMessage(message)

      const response = await axios.post(`${API_POOL_BASE_URL}/api/signature`, {
        address: account,
        id: inputValue,
        signature: signedMessage,
        message: message,
      })

      if (!response.data.success) {
        throw new Error('Failed to submit signature')
      }

      await fetchUsername()
    } catch (error: any) {
      setErrorMsg(error?.response?.data?.message ? error?.response?.data?.message : 'An error occurred.')
      console.error('Error signing or sending message:', error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      <Helmet>
        <title>Points Program | HyperSwap Exchange on Hyperliquid</title>
        <meta name="description" content="" />
        <meta
          name="keywords"
          content="HyperSwap, test platform, faucet, points program, DeFi testing, Hyperliquid blockchain"
        />
        <meta property="og:title" content="Points Program | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Welcome to the Points Program! Experiment with HyperSwap's features, and explore our points program."
        />
        <meta property="og:url" content={`${window.location.origin}/#/testnet`} />
      </Helmet>
      <ContainerStyled>
        <IntroCard variant={1} key="Testnet">
          <h1>Points Program</h1>
          <p>Track your points progress and sign up to the points program.</p>
        </IntroCard>

        <>
          <div>
            <SubContainer bg1={false}>
              <SubContainerHeader>
                <h2 style={{ fontSize: '18px', marginTop: '0' }}>Points Program Overview</h2>
                <p style={{ fontSize: '12px', color: '#C3C5CB', marginBottom: 0 }}>
                  Sign up with a unique Username ID and start earning points on HyperSwap.
                  <br />
                  <br />
                  The more you use the platform, the more points you rack up to climb the leaderboard.
                  <br />
                  <br />
                  Join now and maximize your rewards!
                  <br />
                </p>
              </SubContainerHeader>
              <SubContainerBody>
                {account ? (
                  <AutoColumn gap={'md'}>
                    {username === null ? (
                      <>
                        <ReferralInputPanel
                          id="referral-input"
                          value={inputValue}
                          handleChange={handleChange}
                          error={!!errorMsg}
                          disabled={false}
                        />

                        {errorMsg && <p style={{ color: '#FF6871', margin: 0, fontSize: '12px' }}>Error: {errorMsg}</p>}
                        <ButtonPrimary
                          id="join-pool-button"
                          style={{ padding: 16 }}
                          as={'button'}
                          onClick={sign}
                          disabled={loading || inputValue.length === 0}
                        >
                          <Text
                            fontWeight={400}
                            fontSize={14}
                            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                          >
                            {loading ? 'Signing...' : 'Sign'}
                          </Text>
                        </ButtonPrimary>
                      </>
                    ) : (
                      <>
                        <ReferralInputPanel
                          id="referral-input"
                          value={username}
                          handleChange={handleChange}
                          error={!!errorMsg}
                          disabled={true}
                        />

                        <ContainerPointsStyled>
                          <ItemContainerStyled>
                            <SkeletonText height="40px" width="40%"></SkeletonText>
                            {/*  <span>{ranking ? ranking : 0}</span> */}
                            <h2>Your Rank</h2>
                          </ItemContainerStyled>
                          <ItemContainerStyled>
                            {/*  <span>{roundToDecimalPlace(`${points}`, '0')}</span> */}
                            <SkeletonText height="40px" width="60%"></SkeletonText>
                            <h2>Your Points</h2>
                            {/*   <p style={{ gridColumn: 'span 12', color: 'lightgrey' }}>
                              Last update: {lastUpdate && <> {lastUpdate}</>}{' '}
                            </p> */}
                          </ItemContainerStyled>
                        </ContainerPointsStyled>
                      </>
                    )}
                    <span style={{ fontSize: '14px', color: 'gray' }}>
                      Note: The tracking of the Points Program is not yet available.
                    </span>
                  </AutoColumn>
                ) : (
                  <ConnectWalletContainer>
                    <div>
                      <TYPE.mediumHeader textAlign="center" color={theme.text3}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="48"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-user"
                          style={{ marginBottom: '.5rem' }}
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                        </svg>

                        <div>{'Connect your wallet to see the your points program info.'}</div>
                      </TYPE.mediumHeader>
                      <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px' }} onClick={toggleWalletModal}>
                        Connect a wallet
                      </ButtonPrimary>
                    </div>
                  </ConnectWalletContainer>
                )}
              </SubContainerBody>
            </SubContainer>
          </div>
        </>
      </ContainerStyled>
    </>
  )
}
export default PointsProgram
